import React, { FC, ReactNode } from "react";
import classNames, { Argument } from "classnames/dedupe";
import {
  IMediaBuilderProps,
  MediaBuilder,
  SvgIconType,
} from "../../Utility/MediaBuilder";
import { ISvgIconProps } from "../../Icons";

export type TProductHighlight = {
  /** Unique identifier */
  id: string;
  /** Title of tile */
  header: ReactNode;
  /** Small description text */
  description?: ReactNode;
  /** Icon/image data */
  iconMediaData?: IMediaBuilderProps;
};

export interface IProductHighlightProps extends TProductHighlight {
  classes?: {
    root?: Argument;
  };
}

const ProductHighlight: FC<IProductHighlightProps> = ({
  classes,
  id,
  iconMediaData,
  header,
  description,
}) => (
  <div
    className={classNames("d-flex align-items-center", classes?.root)}
    data-id={id}
    data-testid="ProductHighlight"
  >
    <div className="d-flex justify-content-center align-items-center p-5 me-6 rounded-2 bg-color-grey-200">
      <MediaBuilder
        classes={{ root: "icon-container--medium" }}
        type={iconMediaData?.type as SvgIconType["type"]}
        data={iconMediaData?.data as ISvgIconProps}
      />
    </div>
    <div>
      <div className="text-bold-header mb-6">{header}</div>
      <div className="text-small">{description}</div>
    </div>
  </div>
);

export default ProductHighlight;
